module.exports = __webpack_public_path__ + "img/p1.79105829.jpg";